import esLocale from 'element-ui/lib/locale/lang/es'
const msg = {
    ...esLocale,
    'Home':'Inicio',
    'Products':'Productos',
    'Products Center':'Productos',
    'News':'Noticias',
    'News Updates':'News Updates',
    'Our Department':'Nuestro Departamento',
    'Keep In Touch':'Mantener el contacto',
    'Tel':'Teléfono',
    'Email':'Correo electrónico',
    'Address':'Dirección',
    'We\'d Love To Hear From You':'Nos encantaría oír de usted',
    'Last Name':'Apellido',
    'First Name':'Nombre',
    'Telephone':'Teléfono',
    'Country':'País',
    'Additional Information':'Información Adicional',
    'Submit':'Enviar',
    'Contacts Us':'Contáctenos',
    'E-MAIL':'Correo electrónico',
    'TEL':'Teléfono',
    'Previous':'Anterior',
    'Next':'Siguiente',
    'Latest News':'Últimas Noticias',
    'FTTx':'FTTx',
    'Data Center':'Centro de datos',
    'Customized':'Personalizado',
    'FTTx Solution':'Solución FTTx',
    'Data Center Solution':'Solución de centro de datos',
    'Customized Solution':'Solución personalizada',
    'Specification':'Especificación',
    'Ordering Information':'Información de pedido',
    'Requirement':'Opciones de personalización y pedido',
    'Product Highlights':'Puntos destacados del producto',
    'Related Products':'Productos relacionados',
    关于我们:'Sobre Nosotros',
    解决方案:'Solución',
    产品中心:'Productos',
    公司简介:'Perfil de la empresa',
    组织架构:'Estructura organizacional',
    我们的部门:'Nuestro Departamento',
    发展历程:'Hito',
    荣誉资质:'Certificados y Honores',
    产品展示:'Nuestros Productos',
    查看更多:'Ver todos',
    更多:'Más',
    新闻资讯:'Noticias',
    公司新闻:'Noticias de la empresa',
    行业新闻:'Noticias de la industria',
    联系我们:'Contacto',
    产品分类:'Categoría de Productos',
    所有产品:'Todos Productos',
    光纤连接器:'Conectores de Fibra',
    光纤适配器:'Adaptadores de Fibra',
    光纤衰减器:'Atenuadores de Fibra',
    光纤配线架:'ODF de Fibra',
    其他产品:'Otros Productos',
    搜索:'Buscar',
    关闭:'Cerrar',
    查看全部:'Todo',
    版权所有:'Copyrights © 2020 - ZHEJIANG JIAWEI COMMUNICATION',
    加载更多:'Cargar Más',
    产品证书:'Certificados',
    '提交成功，我们会尽快与您联系！':'¡Nos pondremos en contacto con usted pronto!',
    '提交失败，请稍后重试':'Error al enviar, por favor intente más tarde',
}
export default msg;
